import { ReducerUtil } from 'doctivity-shared/utils';

import {
  API_TAGS_TABLE,
  API_TAGS_LIST,
  API_TAGS_UPSERT,
  API_TAGS_GET,
} from 'store/actions/tagsActions';

export const tags = (state = {}, action = null) => {
  let result = ReducerUtil.simpleReduce(
    state,
    action,
    API_TAGS_TABLE,
    API_TAGS_LIST,
    API_TAGS_UPSERT,
  );
  if (result.actionConsumed) {
    return result.state;
  }

  result = ReducerUtil.reduceSingleGet(state, action, API_TAGS_GET);
  if (result.actionConsumed) {
    return result.state;
  }

  return state;
};
